var Const = /** @class */ (function () {
    function Const() {
    }
    Const.RUN_GET_COUNTRIES_LIST = '/RUN_GET_COUNTRIES_LIST';
    Const.RUN_GET_CITIES_LIST = '/RUN_GET_CITIES_LIST';
    Const.RUN_DELETE_INTERNAL_NOTES = '/RUN_DELETE_INTERNAL_NOTES';
    Const.RUN_EDIT_INTERNAL_NOTES = '/RUN_EDIT_INTERNAL_NOTES';
    Const.RUN_DOWNLOAD_WITHDRAWAL_DATA = '/RUN_DOWNLOAD_WITHDRAWAL_DATA';
    Const.SET_COUNTRIES_LIST = '/SET_COUNTRIES_LIST';
    Const.GET_COUNTRIES_LIST = '/GET_COUNTRIES_LIST';
    Const.SET_CITIES_LIST = '/SET_CITIES_LIST';
    Const.GET_CITIES_LIST = '/GET_CITIES_LIST';
    //fee-history
    Const.RUN_ADMIN_FEE_HISTORY = '/RUN_ADMIN_FEE_HISTORY';
    Const.SET_FEE_HISTORY = '/SET_FEE_HISTORY';
    Const.GET_FEE_HISTORY = '/GET_FEE_HISTORY';
    //pricing
    Const.RUN_GET_PRICING_PLAN_LIST = '/RUN_GET_PRICING_PLAN_LIST';
    Const.SET_PRICING_PLAN_LIST = '/SET_PRICING_PLAN_LIST';
    Const.GET_PRICING_PLAN_LIST = '/GET_PRICING_PLAN_LIST';
    Const.RUN_GET_PRICING_PLAN_DETAIL = '/RUN_GET_PRICING_PLAN_DETAIL';
    Const.SET_PRICING_PLAN_DETAIL = '/SET_PRICING_PLAN_DETAIL';
    Const.GET_PRICING_PLAN_DETAIL = '/GET_PRICING_PLAN_DETAIL';
    Const.RUN_CREATE_PRICING_PLAN = '/RUN_CREATE_PRICING_PLAN';
    Const.RUN_UPDATE_PRICING_PLAN = '/RUN_UPDATE_PRICING_PLAN';
    Const.RUN_UPDATE_PRICING_PLAN_STATUS = '/RUN_UPDATE_PRICING_PLAN_STATUS';
    Const.RUN_UPDATE_CLIENT_PLAN = '/RUN_UPDATE_CLIENT_PLAN';
    Const.RUN_GET_PRICING_OFFER_LIST = '/RUN_GET_PRICING_OFFER_LIST';
    Const.SET_PRICING_OFFER_LIST = '/SET_PRICING_OFFER_LIST';
    Const.GET_PRICING_OFFER_LIST = '/GET_PRICING_OFFER_LIST';
    Const.RUN_GET_PRICING_OFFER_DETAIL = '/RUN_GET_PRICING_OFFER_DETAIL';
    Const.SET_PRICING_OFFER_DETAIL = '/SET_PRICING_OFFER_DETAIL';
    Const.GET_PRICING_OFFER_DETAIL = '/GET_PRICING_OFFER_DETAIL';
    Const.RUN_CREATE_PRICING_OFFER = '/RUN_CREATE_PRICING_OFFER';
    Const.RUN_UPDATE_PRICING_OFFER = '/RUN_UPDATE_PRICING_OFFER';
    Const.RUN_UPDATE_PRICING_OFFER_STATUS = '/RUN_UPDATE_PRICING_OFFER_STATUS';
    //manage-group
    Const.RUN_GET_MANAGE_GROUP_LIST = '/RUN_GET_MANAGE_GROUP_LIST';
    Const.RUN_ADD_EDIT_ADMIN_MANAGE_GROUP_DATA = '/RUN_ADD_EDIT_ADMIN_MANAGE_GROUP_DATA';
    //task
    Const.RUN_GET_TASK_LIST = '/RUN_GET_TASK_LIST';
    Const.RUN_ADD_TASK = '/RUN_ADD_TASK';
    Const.RUN_TASK_UPDATE_STATUS = '/RUN_TASK_UPDATE_STATUS';
    //permission
    Const.SET_PERMISSION_LIST = '/SET_PERMISSION_LIST';
    Const.GET_PERMISSION_LIST = '/GET_PERMISSION_LIST';
    Const.SET_EMAIL_DATA = '/SET_EMAIL_DATA';
    Const.GET_EMAIL_DATA = '/GET_EMAIL_DATA';
    //email
    Const.RUN_EMAIL_SETTING_LIST = '/RUN_EMAIL_SETTING_LIST';
    Const.RUN_ADD_EMAIL_SETTING = '/RUN_ADD_EMAIL_SETTING';
    Const.SET_EMAIL_SETTING_LIST = '/SET_EMAIL_SETTING_LIST';
    Const.GET_EMAIL_SETTING_LIST = '/GET_EMAIL_SETTING_LIST';
    //coupon
    Const.RUN_GET_COUPON_LIST = '/RUN_GET_COUPON_LIST';
    Const.RUN_CREATE_COUPON = '/RUN_CREATE_COUPON';
    Const.RUN_GET_PLAN_COUPON_LIST = '/RUN_GET_PLAN_COUPON_LIST';
    Const.RUN_SUB_EXSIST_LIST = '/RUN_SUB_EXSIST_LIST';
    Const.RUN_SUB_PLAN_LIST = '/RUN_SUB_PLAN_LIST';
    Const.RUN_SUB_PLAN_DETAIL = '/RUN_SUB_PLAN_DETAIL';
    Const.RUN_SUB_OPER = '/RUN_SUB_OPER';
    Const.RUN_UNSUBSCRIBE = '/RUN_UNSUBSCRIBE';
    Const.SET_COUPON_LIST = '/SET_COUPON_LIST';
    Const.GET_COUPON_LIST = '/GET_COUPON_LIST';
    Const.SET_SUB_PLAN_LIST = '/SET_SUB_PLAN_LIST';
    Const.GET_SUB_PLAN_LIST = '/GET_SUB_PLAN_LIST';
    Const.SET_SUB_PLAN_DETAIL = '/SET_SUB_PLAN_DETAIL';
    Const.GET_SUB_PLAN_DETAIL = '/GET_SUB_PLAN_DETAIL';
    Const.SET_SUB_EXSIST_LIST = '/SET_SUB_EXSIST_LIST';
    Const.GET_SUB_EXSIST_LIST = '/GET_SUB_EXSIST_LIST';
    //report
    Const.RUN_GET_REPORTING_LIST = '/RUN_GET_REPORTING_LIST';
    Const.RUN_CREATE_REPORT = '/RUN_CREATE_REPORT';
    Const.SET_REPORTING_LIST = '/SET_REPORTING_LIST';
    Const.GET_REPORTING_LIST = '/GET_REPORTING_LIST';
    Const.SET_EMIR_LIST = '/SET_EMIR_LIST';
    Const.GET_EMIR_LIST = '/GET_EMIR_LIST';
    //public static GET_REPORT_DOC_LINK:string  =  '/GET_REPORT_DOC_LINK'
    //admin
    Const.RUN_GET_ADMIN_LIST = '/RUN_GET_ADMIN_LIST';
    Const.RUN_GET_ADMIN_DETAIL = '/RUN_GET_ADMIN_DETAIL';
    Const.RUN_ADD_ADMIN = '/RUN_ADD_ADMIN';
    Const.RUN_UPDATE_ADMIN_DETAIL = '/RUN_UPDATE_ADMIN_DETAIL';
    Const.SET_ADMIN_LIST = '/SET_ADMIN_LIST';
    Const.GET_ADMIN_LIST = '/GET_ADMIN_LIST';
    Const.SET_ADMIN_DETAIL = '/SET_ADMIN_DETAIL';
    Const.GET_ADMIN_DETAIL = '/GET_ADMIN_DETAIL';
    //resetpassword
    Const.RUN_CHANGE_PASSWORD = '/RUN_CHANGE_PASSWORD';
    Const.SET_GROUP_ADMIN_NAME = '/SET_GROUP_ADMIN_NAME';
    Const.GET_GROUP_ADMIN_NAME = '/GET_GROUP_ADMIN_NAME';
    Const.SET_USER_GROUP_ID = '/SET_USER_GROUP_ID';
    Const.GET_USER_GROUP_ID = '/GET_USER_GROUP_ID';
    //request access
    Const.RUN_REQUEST_OTP = '/RUN_REQUEST_OTP';
    Const.RUN_VERIFY_OTP = '/RUN_VERIFY_OTP';
    //faq
    Const.RUN_CREATE_CATEGORY = '/RUN_CREATE_CATEGORY';
    Const.RUN_CREATE_ARTICLE = '/RUN_CREATE_ARTICLE';
    Const.RUN_GET_ARTICLE_LIST = '/RUN_GET_ARTICLE_LIST';
    Const.RUN_GET_CAT_LIST = '/RUN_GET_CAT_LIST';
    Const.RUN_GET_CAT_DETAIL = '/RUN_GET_CAT_DETAIL';
    Const.RUN_GET_ARTICLE_DETAIL = '/RUN_GET_ARTICLE_DETAIL';
    Const.SET_ARTICLE_LIST = '/SET_ARTICLE_LIST';
    Const.GET_ARTICLE_LIST = '/GET_ARTICLE_LIST';
    Const.SET_CAT_LIST = '/SET_CAT_LIST';
    Const.GET_CAT_LIST = '/GET_CAT_LIST';
    Const.RUN_DELETE_ARTICLEL = '/RUN_DELETE_ARTICLEL';
    Const.RUN_DELETE_CATEGORY = '/RUN_DELETE_CATEGORY';
    //client
    Const.RUN_GET_ALL_INTERNAL_NOTES = '/RUN_GET_ALL_INTERNAL_NOTES';
    Const.RUN_CLOSE_ACCOUNT = '/RUN_CLOSE_ACCOUNT';
    Const.RUN_GET_CLIENT_REPORT = '/RUN_GET_CLIENT_REPORT';
    Const.RUN_ALLOW_FOR_IPV = '/RUN_ALLOW_FOR_IPV';
    Const.RUN_SEND_EMAIL_USER = '/RUN_SEND_EMAIL_USER';
    Const.RUN_GET_ACCOUNT_DETAIL = '/RUN_GET_ACCOUNT_DETAIL';
    Const.SET_WITHDRAWAL_METHOD_RESPONSE = '/SET_WITHDRAWAL_METHOD_RESPONSE';
    Const.GET_WITHDRAWAL_METHOD_RESPONSE = '/GET_WITHDRAWAL_METHOD_RESPONSE';
    Const.RUN_DISABLE2FA = '/RUN_DISABLE2FA';
    Const.RUN_CREATE_ACTIVITY = '/RUN_CREATE_ACTIVITY';
    Const.RUN_GET_ACTIVITY = '/RUN_GET_ACTIVITY';
    Const.CALL_USER = '/CALL_USER';
    Const.RUN_GET_USER_LIST = '/RUN_GET_USER_LIST';
    Const.RUN_WITHDRAWAL_METHODS = '/RUN_WITHDRAWAL_METHODS';
    Const.RUN_GET_LOGS_LIST = '/RUN_GET_LOGS_LIST';
    Const.RUN_GET_LOGS_VIEW = '/RUN_GET_LOGS_VIEW';
    Const.RUN_GET_LOGS_DETAIL = '/RUN_GET_LOGS_DETAIL';
    Const.RUN_GET_USER_VIEW = '/RUN_GET_USER_VIEW';
    Const.RUN_UPDATE_CLIENT_DETAIL = '/RUN_UPDATE_CLIENT_DETAIL';
    Const.RUN_RESET_PASSWORD = '/RUN_RESET_PASSWORD';
    Const.RUN_USER_COUNT = '/RUN_USER_COUNT';
    Const.RUN_USER_NOTIFICATIONS = '/RUN_USER_NOTIFICATIONS';
    Const.RUN_ADD_WITHDRAWAL = '/RUN_ADD_WITHDRAWAL';
    Const.RUN_ADD_TICKET = '/RUN_ADD_TICKET';
    Const.RUN_GET_INTERNAL_NOTES = '/RUN_GET_INTERNAL_NOTES';
    Const.RUN_ADD_INTERNAL_NOTES = '/RUN_ADD_INTERNAL_NOTES';
    Const.RUN_GET_RISK_METRIX = '/RUN_GET_RISK_METRIX';
    Const.RUN_VERIFY_ACCOUNT = '/RUN_VERIFY_ACCOUNT';
    Const.RUN_CREATE_TRADING_ACCOUNT = '/RUN_CREATE_TRADING_ACCOUNT';
    Const.RUN_SEND_MAIL = '/RUN_SEND_MAIL';
    Const.RUN_GET_USER_SETTING = '/RUN_GET_USER_SETTING';
    Const.RUN_UPDATE_USER_SETTING = '/RUN_UPDATE_USER_SETTING';
    Const.RUN_GET_ALL_ROLES = '/RUN_GET_ALL_ROLES';
    Const.RUN_UPDATE_USER_ROLES = '/RUN_UPDATE_USER_ROLES';
    Const.SET_ALL_ROLES = '/SET_ALL_ROLES';
    Const.GET_ALL_ROLES = '/GET_ALL_ROLES';
    Const.SET_USER_LIST = '/SET_USER_LIST';
    Const.GET_USER_LIST = '/GET_USER_LIST';
    Const.SET_LOGS_LIST = '/SET_LOGS_LIST';
    Const.GET_LOGS_LIST = '/GET_LOGS_LIST';
    Const.SET_USER_VIEW = '/SET_USER_VIEW';
    Const.GET_USER_VIEW = '/GET_USER_VIEW';
    Const.SET_USER_COUNT = '/SET_USER_COUNT';
    Const.GET_USER_COUNT = '/GET_USER_COUNT';
    Const.SET_INTERNAL_NOTES = '/SET_INTERNAL_NOTES';
    Const.GET_INTERNAL_NOTES = '/GET_INTERNAL_NOTES';
    Const.SET_RISK_METRIX = '/SET_RISK_METRIX';
    Const.GET_RISK_METRIX = '/GET_RISK_METRIX';
    Const.SET_LOGS_VIEW = '/SET_LOGS_VIEW';
    Const.GET_LOGS_VIEW = '/GET_LOGS_VIEW';
    //public static GET_EMP_STATUS:string  =  '/GET_EMP_STATUS'
    //public static GET_OCCUPATION:string  =  '/GET_OCCUPATION'
    //public static GET_EST_YEARLY_INCOME:string  =  '/GET_EST_YEARLY_INCOME'
    //public static GET_EST_NET_WORTH:string  =  '/GET_EST_NET_WORTH'
    //public static GET_ACCOUNT_TURNOVER:string  =  '/GET_ACCOUNT_TURNOVER'
    //public static GET_GENDER_LIST:string  =  '/GET_GENDER_LIST'
    //public static GET_IDEN_VER:string  =  '/GET_IDEN_VER'
    //public static GET_FUND_SRC:string  =  '/GET_FUND_SRC'
    //public static GET_DEPT_METHD:string  =  '/GET_DEPT_METHD'
    //public static GET_CRED_INS:string  =  '/GET_CRED_INS'
    //public static GET_CHNL_RSK:string  =  '/GET_CHNL_RSK'
    //public static GET_THRD_PARTY:string  =  '/GET_THRD_PARTY'
    //public static GET_STEP:string  =  '/GET_STEP'
    //public static GET_TIMEZONE:string  =  '/GET_TIMEZONE'
    //deposit
    Const.RUN_DEPOSIT_UPDATE_SUSPENSE = '/RUN_DEPOSIT_UPDATE_SUSPENSE';
    Const.RUN_DEPOSIT_ASSIGN = '/RUN_DEPOSIT_ASSIGN';
    Const.RUN_DEPOSIT_UPLOAD = '/RUN_DEPOSIT_UPLOAD';
    Const.RUN_CREATE_DEPOSIT = '/RUN_CREATE_DEPOSIT';
    Const.RUN_GET_DEPOSIT_LIST = '/RUN_GET_DEPOSIT_LIST';
    Const.RUN_GET_DEPOSIT_VIEW = '/RUN_GET_DEPOSIT_VIEW';
    Const.RUN_EDIT_DEPOSIT_DETAILS = '/RUN_EDIT_DEPOSIT_DETAILS';
    Const.RUN_GET_DEPOSIT_TRANSACTION_STATUS = '/RUN_GET_DEPOSIT_TRANSACTION_STATUS';
    Const.RUN_GET_DEPOSIT_TRANSFER = '/RUN_GET_DEPOSIT_TRANSFER';
    Const.RUN_GET_DEPOSIT_FAILED_LIST = '/RUN_GET_DEPOSIT_FAILED_LIST';
    Const.SET_DEPOSIT_LIST = '/SET_DEPOSIT_LIST';
    Const.GET_DEPOSIT_LIST = '/GET_DEPOSIT_LIST';
    Const.SET_DEPOSIT_VIEW = '/SET_DEPOSIT_VIEW';
    Const.GET_DEPOSIT_VIEW = '/GET_DEPOSIT_VIEW';
    //public static GET_DEPOSIT_STATUS:string  =  '/GET_DEPOSIT_STATUS'
    //public static GET_DEPOSIT_METHOD:string  =  '/GET_DEPOSIT_METHOD'
    //bonus
    Const.RUN_GET_BONUS_LIST = '/RUN_GET_BONUS_LIST';
    Const.RUN_GET_BONUS_VIEW = '/RUN_GET_BONUS_VIEW';
    Const.SET_BONUS_LIST = '/SET_BONUS_LIST';
    Const.GET_BONUS_LIST = '/GET_BONUS_LIST';
    Const.SET_BONUS_VIEW = '/SET_BONUS_VIEW';
    Const.GET_BONUS_VIEW = '/GET_BONUS_VIEW';
    //ticket
    Const.RUN_GET_TICKET_LIST = '/RUN_GET_TICKET_LIST';
    Const.RUN_GET_TICKET_VIEW = '/RUN_GET_TICKET_VIEW';
    Const.RUN_TICKET_REASON_LIST = '/RUN_TICKET_REASON_LIST';
    Const.RUN_TICKET_REPLY = '/RUN_TICKET_REPLY';
    Const.RUN_TICKET_APPROVE = '/RUN_TICKET_APPROVE';
    Const.RUN_TICKET_TRANSFER = '/RUN_TICKET_TRANSFER';
    Const.RUN_CLOSE_TICKET = '/RUN_CLOSE_TICKET';
    Const.RUN_TICKET_DOC_APPROVE_REJECT = '/RUN_TICKET_DOC_APPROVE_REJECT';
    Const.RUN_TICKET_APPROVE_MULTIPLE = '/RUN_TICKET_APPROVE_MULTIPLE';
    Const.RUN_ESCALTE_TICKET = '/RUN_ESCALTE_TICKET';
    Const.RUN_GET_GROUP_ADMIN_NAME = '/RUN_GET_GROUP_ADMIN_NAME';
    Const.RUN_GET_TICKET_REASON_LIST = '/RUN_GET_TICKET_REASON_LIST';
    Const.RUN_CREATE_WALLET = '/RUN_CREATE_WALLET';
    Const.RUN_CREATE_ACT_ACCOUNT = '/RUN_CREATE_ACT_ACCOUNT';
    //zip
    Const.GET_ZIP_DOCS_LINK = '/GET_ZIP_DOCS_LINK';
    Const.SET_TICKET_LIST = '/SET_TICKET_LIST';
    Const.GET_TICKET_LIST = '/GET_TICKET_LIST';
    Const.SET_TICKET_REASON_LIST = '/SET_TICKET_REASON_LIST';
    Const.GET_TICKET_REASON_LIST = '/GET_TICKET_REASON_LIST';
    Const.SET_TICKET_VIEW = '/SET_TICKET_VIEW';
    Const.GET_TICKET_VIEW = '/GET_TICKET_VIEW';
    Const.SET_TICKET_DOCS = '/SET_TICKET_DOCS';
    Const.GET_TICKET_DOCS = '/GET_TICKET_DOCS';
    Const.SET_TICKET_REASON_LIST2 = '/SET_TICKET_REASON_LIST2';
    Const.GET_TICKET_REASON_LIST2 = '/GET_TICKET_REASON_LIST2';
    Const.SET_TICKET_DATA = '/SET_TICKET_DATA';
    Const.GET_TICKET_DATA = '/GET_TICKET_DATA';
    //public static GET_TICKET_DOCS_LINK:string  =  '/GET_TICKET_DOCS_LINK'
    Const.GET_DEPARMENT_LIST = '/GET_DEPARMENT_LIST';
    //public static GET_TICKET_STATUS:string  =  '/GET_TICKET_STATUS'
    //public static GET_TICKET_REASON:string  =  '/GET_TICKET_REASON'
    //public static GET_TICKET_REPLY_PRE:string  =  '/GET_TICKET_REPLY_PRE'
    //withdrawal
    Const.RUN_DOWNLOAD_FILES = '/RUN_DOWNLOAD_FILES';
    Const.RUN_SEND_WITH_DATA = '/RUN_SEND_WITH_DATA';
    Const.RUN_GET_WITHDRAWAL_LIST = '/RUN_GET_WITHDRAWAL_LIST';
    Const.RUN_GET_WITHDRAWAL_LIST_MAKER = '/RUN_GET_WITHDRAWAL_LIST_MAKER';
    Const.RUN_GET_WITHDRAWAL_VIEW = '/RUN_GET_WITHDRAWAL_VIEW';
    Const.RUN_EDIT_WITHDRAWAL_DETAILS = '/RUN_EDIT_WITHDRAWAL_DETAILS';
    Const.SET_WITHDRAWAL_LIST = '/SET_WITHDRAWAL_LIST';
    Const.SET_WITHDRAWAL_LIST_MAKER = '/SET_WITHDRAWAL_LIST_MAKER';
    Const.GET_WITHDRAWAL_LIST = '/GET_WITHDRAWAL_LIST';
    Const.GET_WITHDRAWAL_LIST_MAKER = '/GET_WITHDRAWAL_LIST_MAKER';
    Const.SET_WITHDRAWAL_VIEW = '/SET_WITHDRAWAL_VIEW';
    Const.GET_WITHDRAWAL_VIEW = '/GET_WITHDRAWAL_VIEW';
    //public static GET_WITHDRAWAL_TYPE:string  =  '/GET_WITHDRAWAL_TYPE'
    //public static GET_WITHDRAWAL_METHOD:string  =  '/GET_WITHDRAWAL_METHOD'
    //public static GET_WITHDRAWAL_METHODS:string  =  '/GET_WITHDRAWAL_METHODS'
    //public static GET_WITHDRAWAL_STATUS:string  =  '/GET_WITHDRAWAL_STATUS'
    Const.GET_WITHDRAWAL_DOC_LINK = '/GET_WITHDRAWAL_DOC_LINK';
    //trading
    Const.RUN_GET_TRADING_LIST = '/RUN_GET_TRADING_LIST';
    Const.RUN_GET_TRADING_VIEW = '/RUN_GET_TRADING_VIEW';
    Const.RUN_EDIT_TRADING_DETAILS = '/RUN_EDIT_TRADING_DETAILS';
    Const.RUN_CHANGE_LEVERAGE = '/RUN_CHANGE_LEVERAGE';
    /*public static RUN_DELETE_TRADING_ACCOUNT:string  = '/RUN_DELETE_TRADING_ACCOUNT'*/
    Const.SET_TRADING_LIST = '/SET_TRADING_LIST';
    Const.GET_TRADING_LIST = '/GET_TRADING_LIST';
    Const.SET_TRADING_VIEW = '/SET_TRADING_VIEW';
    Const.GET_TRADING_VIEW = '/GET_TRADING_VIEW';
    Const.RUN_GET_TRADING_ORDERS = '/RUN_GET_TRADING_ORDERS';
    Const.SET_TRADING_ORDERS = '/SET_TRADING_ORDERS';
    Const.GET_TRADING_ORDERS = '/GET_TRADING_ORDERS';
    //public static GET_DEMO_LIVE:string  =  '/GET_DEMO_LIVE'
    //public static GET_CURRENCY:string  =  '/GET_CURRENCY'
    //bonus
    //public static GET_BONUS_TYPE:string  =  '/GET_BONUS_TYPE'
    //public static GET_BONUS_STATUS:string  =  '/GET_BONUS_STATUS'
    // NOTIFICATION_LIST
    Const.RUN_GET_NOTIFICATION_LIST = '/RUN_GET_NOTIFICATION_LIST';
    Const.SET_NOTIFICATION_LIST = '/SET_NOTIFICATION_LIST';
    Const.GET_NOTIFICATION_LIST = '/GET_NOTIFICATION_LIST';
    Const.SET_NOTIFICATION_READ_LIST = '/SET_NOTIFICATION_READ_LIST';
    Const.GET_NOTIFICATION_READ_LIST = '/GET_NOTIFICATION_READ_LIST';
    Const.SET_NOTIFICATION_UNREAD_LIST = '/SET_NOTIFICATION_UNREAD_LIST';
    Const.GET_NOTIFICATION_UNREAD_LIST = '/GET_NOTIFICATION_UNREAD_LIST';
    Const.RUN_READ_UNREAD_NOTIFICATION = '/RUN_READ_UNREAD_NOTIFICATION';
    // WEB HOOKS
    Const.RUN_GET_WEB_HOOKS = '/RUN_GET_WEB_HOOKS';
    Const.SET_WEB_HOOKS = '/SET_WEB_HOOKS';
    Const.GET_WEB_HOOKS = '/GET_WEB_HOOKS';
    Const.RUN_WEB_HOOKS_RETRY = '/RUN_WEB_HOOKS_RETRY';
    Const.RUN_GET_DEPOSIT_WITHDRAW_DOWNLOAD = '/RUN_GET_DEPOSIT_WITHDRAW_DOWNLOAD';
    Const.RUN_GET_CLIENT_DATA = '/RUN_GET_CLIENT_DATA';
    Const.SET_CLIENT_DATA = '/SET_CLIENT_DATA';
    Const.GET_CLIENT_DATA = '/GET_CLIENT_DATA';
    Const.RUN_GET_ORDER_HISTORY = '/RUN_GET_ORDER_HISTORY';
    Const.SET_ORDER_HISTORY = '/SET_ORDER_HISTORY';
    Const.GET_ORDER_HISTORY = '/GET_ORDER_HISTORY';
    Const.SET_ORDER_HISTORY_SOCIAL_DATA = '/SET_ORDER_HISTORY_SOCIAL_DATA';
    Const.GET_ORDER_HISTORY_SOCIAL_DATA = '/GET_ORDER_HISTORY_SOCIAL_DATA';
    return Const;
}());
export { Const };



//////////////////
// WEBPACK FOOTER
// ./src/plugins/fxView/provider/candle-history/lib/const.cls.ts
// module id = H1/N
// module chunks = 66